import constants from "constants/constants";

const {
  PAGE_ROUTES: { COMPLETE_PASSWORD_RESET_ROUTE }
} = constants;

export const getRequestResetPrefill = search => {
  return new URLSearchParams(search).get("username") || "";
};

export const getPasswordResetKey = search => {
  return new URLSearchParams(search).get("id") || "";
};

export const getTargetResetUrl = () => {
  return `${window.location.origin}${COMPLETE_PASSWORD_RESET_ROUTE}?id=`;
};